<template>
    <div>
        <div
            :class="{'col-md-3 mb-2 mb-md-0' : fixed && !paramsVariantDoesNotExist }"
        >
            <div class="d-md-flex align-items-center mr-0">
                <label
                    class="custom-formField--select chosen-configurator mb-0 mr-md-2 konfiguratorRow__activator"
                >
                    <chosen-select
                        :values="colorData"
                        :value="colorId"
                        identifier="colorId"
                        @input="selectColor"
                    >
                        <template v-slot:selectText>
                            {{
                                $t('components.SheetVariantSelect.selectColor')
                            }}
                        </template>
                        <template v-slot:item="slotProps">
                            <span
                                class="color-dot"
                                :style="{'background-color' : slotProps.item.colorHash}"></span>
                            <span class="list-result-name">
                                {{ config.colorNameCreator(slotProps.item) }}
                            </span>
                        </template>
                    </chosen-select>
                </label>
            </div>
        </div>
        <div
            :class="{'col-md-3 mb-2 mb-md-0' : fixed && !paramsVariantDoesNotExist }"
        >
            <div class="d-md-flex align-items-center mr-0">
                <label
                    class="custom-formField--select chosen-configurator mb-0 mr-md-2 konfiguratorRow__activator"
                >
                    <chosen-select
                        :values="sizeData"
                        :value="sizeId"
                        identifier="sizeId"
                        @input="selectSize"
                        :disabled="colorId == ''"
                    >
                        <template v-slot:selectText>
                            {{
                                $t('components.SheetVariantSelect.selectSize')
                            }}
                        </template>
                        <template class="text-nowrap" v-slot:item="slotProps">
                            <span class="list-result-name list-result-name-limited">
                                {{ slotProps.item.sizeName }}
                            </span>

                            <span class="ml-1"
                                  v-if="slotProps.item.priceAction"
                                  v-text="$nf(slotProps.item.priceAction.priceWithVat, 'currency' + slotProps.item.price.currency.code, 'cs-CZ')"
                            />

                            <span class="ml-1 mr-1"
                                  :class="{ 'line-through' : slotProps.item.priceAction !== null }"
                                  v-text="$nf(slotProps.item.price.priceWithVat, 'currency' + slotProps.item.price.currency.code, 'cs-CZ')"
                            />

                            <span class="ml-auto stock-dot" :class="{ 'out-of-stock' : slotProps.item.storeQuantity < 1 }"></span>

                        </template>
                    </chosen-select>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import ChosenSelect from "./ChosenSelect"

export default {
    name: 'sheet-variant-select',
    components: {ChosenSelect},
    data() {
        return {};
    },
    props: {
        product: {},
        fixed: {},
        groupCode: {},
        paramsVariantDoesNotExist: {},
        typeCode: {},
        typeText: {},
        config: {}
    },
    computed: {
        colorId() {
            var config = this.config;
            if(!this.product)  {
                return '';
            }
            return this.product.parameters.find(function(tp) {
                return tp.id === config.colorId;
            }).value;
        },
        sizeId() {
            var config = this.config;
            if(!this.product)  {
                return '';
            }
            return this.product.parameters.find(function(tp) {
                return tp.id === config.sizeId;
            }).value;
        },
        currentCollectionId() {
            return this.$store.getters.currentCollectionId;
        },
        variants() {
            return this.$store.getters.getVariantsForType(this.product.type);
        },
        colorData() {
            var config = this.config;
            var data = this.variants.map(function (variant) {
                var color = variant.technicalParameters.find(function (tp) {
                    return tp.id === config.colorId;
                });
                var colorHash = variant.technicalParameters.find(function (tp) {
                    return tp.id === config.colorHashId;
                })
                return {
                    colorId: color.value.id,
                    colorName: color.value.value,
                    colorHashId: colorHash.value.id,
                    colorHash: colorHash.value.value,
                    fabric: variant.fabric
                }
            });
            return data.uniqueObject('colorId');
        },
        sizeData() {
            if(!this.colorId) {
                return [];
            }
            return this.getSizeData(this.colorId)
        }

    },
    watch: {
        colorId() {
            this.selectImage();
        },
        sizeId() {
            this.selectImage();
        },
    },
    methods: {
        selectColor(colorId) {
            var data = this.colorData.find(function (item) {
                return item.colorId === colorId;
            })
            var sizes = this.getSizeData(colorId);
            var values = [{tpId: this.config.colorId, value: colorId}, {tpId: this.config.colorHashId, value: data.colorHashId}];
            if(sizes.length === 1) {
                values.push({tpId: this.config.sizeId, value: sizes[0].sizeId});
            }
            this.$emit('input', {values: values});
        },
        selectSize(sizeId) {
            this.$emit('input', {values: [{tpId: this.config.sizeId, value: sizeId}]});
        },
        selectImage(){

            var image = this.$store.getters.variantImage(this.getVariantId(), this.product.type);
            if (image) {
                this.$emit('changeImage',
                    {
                        preview: image.preview,
                        big: image.big,
                    });
            }
        },
        getSizeData(colorId) {
            var config = this.config;
            var data = this.variants
                .filter(function (variant) {
                    return variant.technicalParameters.find(function (tp) {
                        return tp.id === config.colorId;
                    }).value.id === colorId;
                })
                .map(function (variant) {
                    var size = variant.technicalParameters.find(function (tp) {
                        return tp.id === config.sizeId;
                    });

                    return {
                        sizeId: size.value.id,
                        sizeName: size.value.value,
                        price: variant.price,
                        priceAction: variant.priceAction,
                        storeQuantity: variant.storeQuantity
                    }
                });
            return data.uniqueObject('sizeId');
        },
        getVariantId() {
            const config = this.config;
            const selectedColorId = this.colorId;
            const selectedSizeId = this.sizeId;

            let variantId = null;

            this.variants.forEach(function (variant) {
                const color = variant.technicalParameters.find((tp) => tp.id === config.colorId);
                if (color && color.value.id === selectedColorId) {
                    const size = variant.technicalParameters.find((tp) => tp.id === config.sizeId);
                    if (size && size.value.id === selectedSizeId) {
                        variantId = variant.variantId;
                    }
                }
            });

            return variantId;
        }
    }
}
</script>
